export default __webpack_public_path__ + "arrow-up-on-a-black-circle-background.png";